import LiveState from './LiveState';
class Scene {
    constructor(position) {
        this.position = -1;
        LiveState.scenes[position] = this;
        this.position = position;
    }
    fire() {
        for (const track of LiveState.tracks) {
            if (track.clipSlots[this.position]) {
                track.clipSlots[this.position].fire();
            }
        }
    }
}
export default Scene;
//# sourceMappingURL=Scene.js.map